import React from 'react';
import {Box, Text, VStack, HStack, Heading, Pressable} from 'native-base';
import {IBalanceDetail} from '../../../../../../interfaces/dtos';
import {BolivarIcon, DollarIcon} from '../../../../../../components/icons';

interface CustomProps {
  onPress: () => void;
  rowType: 'odd' | 'even';
}

type ItemProps = CustomProps & Omit<IBalanceDetail, 'fullInfo'>;

const BalanceListItem = (props: ItemProps) => {
  const {id, type, amount, onPress, rowType} = props;

  const handleOnPress = () => {
    onPress();
  };

  const getStripedColor = () => {
    if (rowType === 'odd') {
      return '#FFFFFF';
    }
    return '#F3F9FF';
  };

  return (
    <Pressable onPress={() => handleOnPress()}>
      <HStack
        width="100%"
        backgroundColor={getStripedColor()}
        paddingY={3}
        paddingX={5}>
        <VStack flex={1}>
          <HStack space={5}>
            <VStack justifyContent="center" space="0" flex={1}>
              <Box height="5" justifyContent="center">
                <Heading size="sm" fontWeight="medium" color="black">
                  {id}
                </Heading>
              </Box>
              <Box height="5" justifyContent="center" marginTop={1}>
                <Text
                  color="#99A2B4"
                  fontSize={'sm'}
                  ellipsizeMode="tail"
                  numberOfLines={1}>
                  {type.label}
                </Text>
              </Box>
            </VStack>
            <HStack w="100">
              <VStack justifyContent="center" space="1">
                <Box height="5" justifyContent="center">
                  <DollarIcon />
                </Box>
                <Box height="5" justifyContent="center" marginTop={1}>
                  <BolivarIcon />
                </Box>
              </VStack>
              <VStack justifyContent="flex-end" space="1" w={'85'}>
                <Box height="5" alignItems={'flex-end'} paddingLeft="2">
                  <Text fontWeight="bold" color="#06355E">
                    {amount.foreign}
                  </Text>
                </Box>
                <Box
                  height="5"
                  alignItems={'flex-end'}
                  paddingLeft="2"
                  marginTop={1}>
                  <Text fontWeight="bold" color="#06355E">
                    {amount.local}
                  </Text>
                </Box>
              </VStack>
            </HStack>
          </HStack>
        </VStack>
      </HStack>
    </Pressable>
  );
};

export default BalanceListItem;
